module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAAXNSR0IArs4c6QAAARNJREFUOBHtU8ENwjAMbBHvhFlYiSWqDlD1AxvwYh8W4RX6p+REHTmO3ZQfDypVMTn7uFyuTfN/Fgda7sQ4jj6EcGrb1vF91PM8P733167rgsTwu+/74zAMd8L2VGAFaSQ4x5dvpzriqC9pY6XYcUxT+g3OezNiHJeDsq7hvD+zAh7iuJpykALnw2t1RjxN0yE23+IlPNaGtmAZcRx4LW+a1ZJC6q2EYFgSw/PMdysptYRkJJG0UKz5DUXWPjA8krhQbCXB2v/QllYUirWkkMdEoq1Vj5cL2vS18T+QxIViatbSQRhO4JzLMi6JC49p2EoHw1Gmk8nLMxXXUiBxSWwqrqVA4tIKU7GWDrJhS0qo93fXN6Xlk1VrlcqqAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/Align/layout_ValighJustify_disabled.png
// module id = 316
// module chunks = 0